import { useMenu } from '../context/MenuContext';
import { useCart } from '../context/CartContext';
import { useI18n } from '../i18n';
import { ZoneMap } from './ZoneMap';

export function InfoPage() {
  const { business, onlineStatus, deliveryZones, googleApiKey } = useMenu();
  const { setView } = useCart();
  const { t } = useI18n();

  return (
    <div className="hc-info-page">
      <div className="hc-info-header">
        <button className="hc-back-btn" onClick={() => setView('menu')}>&larr; {t('info.back')}</button>
        <h2>{t('info.title')}</h2>
      </div>

      {/* Delivery Zone Map */}
      {googleApiKey && deliveryZones && deliveryZones.length > 0 && (
        <section className="hc-info-section">
          <ZoneMap zones={deliveryZones} googleApiKey={googleApiKey} height="300px" />
        </section>
      )}

      {/* Delivery Zones Table */}
      {deliveryZones && deliveryZones.length > 0 && (
        <section className="hc-info-section">
          <h3>{t('info.deliveryZones')}</h3>
          <table className="hc-info-table">
            <thead>
              <tr>
                <th></th>
                <th>{t('info.zoneMin')}</th>
                <th>{t('info.zoneFee')}</th>
              </tr>
            </thead>
            <tbody>
              {deliveryZones.map((zone) => (
                <tr key={zone.id}>
                  <td className="hc-info-zone-name">{zone.name}</td>
                  <td>{zone.minimum_order != null ? `${zone.minimum_order.toFixed(2)} €` : '—'}</td>
                  <td>
                    {zone.delivery_fee_item
                      ? `${Number(zone.delivery_fee_item.price).toFixed(2)} €`
                      : t('info.zoneFree')}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      )}

      {/* Working Hours */}
      {onlineStatus?.schedule && onlineStatus.schedule.length > 0 && (
        <section className="hc-info-section">
          <h3>{t('info.deliveryHours')}</h3>
          <div className="hc-info-schedule">
            {onlineStatus.schedule.map((entry) => (
              <div key={entry.day} className={`hc-info-schedule-row ${!entry.active ? 'hc-inactive' : ''}`}>
                <span className="hc-info-day">{t(`day.${entry.day}` as any)}</span>
                <span className="hc-info-time">
                  {entry.active ? `${entry.open} - ${entry.close}` : '—'}
                </span>
              </div>
            ))}
          </div>
        </section>
      )}

      {/* Payment Methods */}
      <section className="hc-info-section">
        <h3>{t('info.paymentMethods')}</h3>
        <ul className="hc-info-list">
          <li>{t('checkout.paymentCash')}</li>
          <li>{t('checkout.paymentCard')}</li>
        </ul>
      </section>

      {/* Contact */}
      {business && (
        <section className="hc-info-section">
          {(business.address || business.city) && (
            <div className="hc-info-contact">
              <strong>{t('info.address')}</strong>
              <span>{[business.address, business.city].filter(Boolean).join(', ')}</span>
            </div>
          )}
          {business.number && (
            <div className="hc-info-contact">
              <strong>{t('info.phone')}</strong>
              <a href={`tel:${business.number}`}>{business.number}</a>
            </div>
          )}
        </section>
      )}
    </div>
  );
}
